import useRideryCodes from "../../../hooks/useRideryCodes.js";
import { ActionButton } from "../../common/Buttons/Buttons";
import { Header } from "../../common/Header/Header.jsx";
import { useDropzone } from "react-dropzone";
import { RideryCodesTable } from "./RideryCodesTable.jsx";
import { rideryCodesTableHeader } from "./HeaderRideryCodesTable.js";
import { LoadSpinner } from "../../common/LoadSpinner/LoadSpinner.jsx";
import { UploadRideryCodesModal } from "./UploadRideryCodesModal.jsx";
import BlockRideryCodesModal from "./BlockRideryCodesModal.jsx";

export default function RideryCodes() {
  const {
    isLoading,
    showUploadModal,
    onDrop,
    createRideryCodes,
    handlePageChange,
    setShowUploadModal,
    setFileUploaded,
    fileUploaded,
    handleCloseModal,
    rideryCodeData,
    handleBlockCode,
    cancelBlockModal,
    openBlockModal,
    setOpenBlockModal
  } = useRideryCodes();

  const handleShowModal = () => {
    setShowUploadModal(true);
  };

  const { getRootProps, getInputProps } = useDropzone({ onDrop });

  return (
    <>
      <Header />
      <LoadSpinner show={isLoading} />
      <div className="service-with-container container">
        <div
          className=""
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <h1 className="title-component">Códigos Ridery</h1>
        </div>
        <div
          className="breadcrumb-container"
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-end",
            marginBottom: "1%",
          }}
        >
          <ActionButton
            action={() => handleShowModal()}
            label={"Nueva Carga"}
          />
        </div>
        <div className="gray-line"></div>
        <div className="filter-button-container"></div>
        <br />
        <RideryCodesTable
          header={rideryCodesTableHeader}
          dataTable={rideryCodeData}
          handlePageChange={handlePageChange}
          isLoading={isLoading}
          changeStatusCode={(v) => setOpenBlockModal(v)}
        />
      </div>
      <UploadRideryCodesModal
        show={showUploadModal}
        handleCloseModal={handleCloseModal}
        fileUploaded={fileUploaded}
        getRootProps={getRootProps}
        getInputProps={getInputProps}
        setFileUploaded={setFileUploaded}
        message="Arrastrar documento"
        upload={createRideryCodes}
      />
      <BlockRideryCodesModal
        show={openBlockModal.isOpen}
        action={handleBlockCode}
        cancel={cancelBlockModal}
      />
    </>
  );
}
